import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbAuthService } from '@nebular/auth';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class BotApiInterceptor implements HttpInterceptor {
  private readonly API_BASE_URL = environment.API_BASE_PATH;

  constructor(private authService: NbAuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // N'intercepte que les requêtes vers l'API principale
    if (!request.url.startsWith(this.API_BASE_URL)) {
      return next.handle(request);
    }

    return this.authService.getToken()
      .pipe(
        switchMap(token => {
          if (token.isValid()) {
            // Clone la requête et ajoute le token dans l'en-tête Authorization
            const authReq = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token.getValue()}`,
              },
            });
            return next.handle(authReq);
          }
          return next.handle(request);
        }),
      );
  }
} 